
export const API_URL = 'https://api.valparx.com/';
export const AUTH_TOKEN = 'tC4yxHZhSqEcfq4iREo7RDFRQbFdeyq2JvKnbLyKp4yMZR7J4Gcr';
export const COOKIE_KEY = '_ga_Y32UM48';
export const LOGIN_URL = 'https://login.valparx.com/';